// for BOOKING STATUS
export const STATUS_LOCATING_DRIVER = 'locating_driver'
export const STATUS_LOCATING_DRIVER_TIMEOUT = 'locating_driver_timeout'
export const STATUS_DRIVER_ACCEPT_BOOKING = 'driver_accept_booking'
export const STATUS_FLEET_ACCEPT_BOOKING = 'fleet_accept_booking'
export const STATUS_DELIVERY_IN_PROGRESS = 'delivery_in_progress'
export const STATUS_DELIVERY_COMPLETED = 'delivery_completed'
export const STATUS_UNDELIVERABLE = 'undeliverable'
export const STATUS_CANCELLED = 'canceled'
export const STATUS_CS_FINDING_DRIVER = 'cs_finding_driver'
export const STATUS_WAITING_FOR_CUSTOMER = 'waiting_for_customer'
export const STATUS_CANCELED_REBOOK = 'canceled_rebook'
export const STATUS_FLEET_TIMEOUT = 'fleet_timeout'
export const STATUS_SAVE_AS_DRAFT = 'draft_pending'
export const STATUS_ASSIGNING_DRIVER = 'assigning_driver'
export const STATUS_ASSIGNING_DRIVER_TIMEOUT = 'assigning_driver_timeout'
export const STATUS_DRIVER_DECLINED_BOOKING = 'driver_declined_booking'
export const STATUS_NEED_RECOVERY = 'recovering'
export const BUSINESS_PROGRAM = 'business'
export const PERSONAL = 'personal'
export const NORMAL_CONTACT = 'normal'

// for BOOKING RECOVERY STATUS
export const RECOVERY_STATUS_REQUEST_RECOVERY = 'request_recovery'
export const RECOVERY_STATUS_DECLINE_RECOVERY = 'decline_recovery'

export const BATCH_STATUS_CONFIRMED = 'confirmed'
export const BATCH_STATUS_UNCONFIRMED = 'unconfirmed'
export const BATCH_STATUS_ARRANGING = 'arranging'
export const BATCH_STATUS_INPROGRESS = 'in_progress'
export const BATCH_STATUS_PARTIAL = 'partial'
export const BATCH_STATUS_PARTIALLY_CONFIRMED = 'partially_confirmed'
export const BATCH_STATUS_COMPLETED = 'completed'
export const BATCH_STATUS_CANCELED = 'canceled'
export const BATCH_STATUS_DRAFT = 'draft'
export const BATCH_TEMPLATE_INVIDUAL = 'invidual'
export const BATCH_TEMPLATE_COMPANY = 'company'
export const BATCH_STATUS_PENDING = 'pending'
export const BATCH_STATUS_SAVED = 'favorited'
export const BATCH_STATUS_DRIVER_ON_THE_WAY = 'driver_on_the_way'

export const OTHER_OPTION = 'Other'

export const BADGE_COLOR_MAP = {
  arranging: 'bg-gray',
  confirmed: 'bg-dark-green',
  partial: 'bg-red',
  partially_confirmed: 'bg-red',
  unconfirmed: 'bg-red',
  completed: 'bg-green',
  canceled: 'bg-red',
  draft: 'bg-gray-l',
}

export const FRESH_CHAT_CHANNEL = 'Chat with Us'
export const FRESH_CHAT_CHANNEL_PH = 'Booking Recovery'
export const FRESH_CHAT_CHANNEL_TH = 'Welcome to the Revolution'

export const SERVICE_D2D = 'D2D'
export const SERVICE_P2D = 'P2D'
